<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    width="1000px"
    title="账套选择"
    @close="closeDialog"
  >
    <div class="account-set-box">
      <div v-if="sourceAccountSets.length > 6" class="search-box">
        <el-input v-model="keyword" placeholder="请输入搜索关键字" clearable @input="searchData" />
      </div>
      <el-row v-loading="loading" class="main-box">
        <el-col v-for="item in accountSets" :key="item.id" :span="8" class="item-box">
          <el-card class="card-box">
            <div slot="header" class="clearfix">
              <div class="alias-box" :title="item.alias">{{ item.alias }}</div>
              <div class="name-box">{{ item.name }}</div>
            </div>
            <div class="account-box-card-body">
              <div class="account-card-info">
                <div class="account-card-info-row">账套类型 {{ formatAccountSetType(item.accountSetType) }}</div>
                <div class="account-card-info-row">启用日期 {{ item.beginDate | fmtDate }}</div>
                <div class="account-card-info-row expire-date">
                  到期日期 {{ item.expireDate | fmtDate }}
                </div>
              </div>
              <div class="account-card-actions">
                <el-button
                  type="primary"
                  round
                  :disabled="item.code === currentAccountSetCode"
                  @click="switchAccountSet(item)"
                >选择账套</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col v-if="accountSets.length === 0" :span="8" class="item-box">
          <el-card class="card-box">
            <div style="text-align: center; height: 180px; padding-top: 80px;">暂无数据</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { parseTime, debounce } from '@/utils';
import { selectAccountSet, getCurrentAccountSet } from '@/api/accountSet';
import { formatAccountSetType } from '@/constants/account-set-types';
export default {
  name: 'AccountSet',
  filters: {
    fmtDate (val) {
      return parseTime(val, '{y}-{m}-{d}');
    }
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      keyword: '',
      sourceAccountSets: [],
      accountSets: []
    }
  },
  computed: {
    currentAccountSet () {
      return getCurrentAccountSet();
    },
    currentAccountSetCode () {
      if (this.currentAccountSet) {
        return this.currentAccountSet.code;
      }
      return '';
    }
  },
  watch: {
    data: {
      handler (val) {
        this.syncAccountSets(val);
      },
      immediate: true
    },
    showDialog: {
      handler (val) {
        this.dialogVisible = val;
      },
      immediate: true
    }
  },
  methods: {
    formatAccountSetType,
    openDialog () {
      this.dialogVisible = true;
    },
    closeDialog () {
      this.$emit('update:showDialog', false);
    },
    syncAccountSets (list) {
      this.sourceAccountSets = this.filterAvailableAccountSets(list);
      this.applySearchFilter();
    },
    filterAvailableAccountSets (list) {
      return (list || []).filter((item) => {
        return !this.isAccountSetExpired(item && item.expireDate);
      });
    },
    applySearchFilter () {
      const keyword = (this.keyword || '').trim();
      if (!keyword) {
        this.accountSets = [...this.sourceAccountSets];
        return;
      }
      this.accountSets = this.sourceAccountSets.filter((item) => {
        const name = item.name || '';
        const alias = item.alias || '';
        return name.indexOf(keyword) > -1 || alias.indexOf(keyword) > -1;
      });
    },
    parseDateOnly (val) {
      if (!val) {
        return null;
      }
      if (val instanceof Date) {
        return new Date(val.getFullYear(), val.getMonth(), val.getDate());
      }
      const match = String(val).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (!match) {
        return null;
      }
      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        return null;
      }
      return date;
    },
    isAccountSetExpired (expireDate) {
      const expireDateOnly = this.parseDateOnly(expireDate);
      if (!expireDateOnly) {
        return false;
      }
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return expireDateOnly.getTime() < today.getTime();
    },
    searchData: debounce(function () {
      this.loading = true;
      try {
        this.applySearchFilter();
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false;
      }
    }, 100),
    async switchAccountSet (item) {
      if (this.currentAccountSetCode === item.code) {
        return;
      }
      try {
        if (!this.currentAccountSetCode) {
          const selectedAccountSet = await selectAccountSet(item.code);
          await this.$store.dispatch('app/setCurrentAccountSet', {
            code: item.code,
            version: Date.now()
          }, { root: true });
          this.$store.commit('user/SET_ASSIST_VISIBLE', !!selectedAccountSet.enableAssist);
          await this.$store.dispatch('tagsView/delAllViews');
          location.href = '/';
          return;
        }
        await this.$confirm(`您确认要切换到账套【${item.alias || item.name}】吗?`, '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const selectedAccountSet = await selectAccountSet(item.code);
        await this.$store.dispatch('app/setCurrentAccountSet', {
          code: item.code,
          version: Date.now()
        }, { root: true });
        this.$store.commit('user/SET_ASSIST_VISIBLE', !!selectedAccountSet.enableAssist);
        await this.$store.dispatch('tagsView/delAllViews');
        location.href = '/';
      } catch (err) {
        console.log(err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 20px;

  .search-box {
    .el-input {
      width: 400px;
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }

  .main-box {
    max-height: 500px;
    overflow-y: auto;

    .item-box {
      padding: 10px;
      height: 260px;
      .el-card__body {
        text-align: center;
      }
    }

    .card-box {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .card-box ::v-deep .el-card__header {
      flex-shrink: 0;
      height: 78px;
    }

    .card-box ::v-deep .el-card__body {
      flex: 1;
      min-height: 0;
    }

    .account-box-card-body {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      align-items: center;
      text-align: center;
      gap: 16px;
    }

    .account-card-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 7px;
    }

    .account-card-info-row {
      line-height: 18px;
      white-space: nowrap;
    }

    .account-card-actions {
      line-height: 1;
    }

    .expire-date {
      color: #e6a23c;
    }

    .alias-box {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 20px;
    }

    .name-box {
      color: #e6a23c;
      font-size: small;
      margin-top: 10px;
      display: block;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 18px;
    }
  }
}
</style>
